document.addEventListener('DOMContentLoaded', () => {
// $(document).ready(function() {
  if ($(".announcement-bar__close-button").length > 0) {
    let close_btns = $(".announcement-bar__close-button");
    
    close_btns.each((index, close_btn) => {
      let parent_section = $(close_btn).closest(".section-announcement");

      
      $(close_btn).on("click", () => {
				parent_section.hide();
				document.body.classList.add("announcement-hide");
			});
    });
  }
// });


  document.querySelectorAll('[data-announcement-swiper]').forEach((slider) => {
    if (slider.swiper) return;

    slider.swiper = new Swiper(slider, {
      slidesPerView: 1,
      loop: true,  
      speed: 800,           
      effect: 'slide',
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },

      navigation: {
        nextEl: slider.querySelector('.announcement-next'),
        prevEl: slider.querySelector('.announcement-prev'),
      },
    });
  });
});

